import { render, staticRenderFns } from "./VendorsTable.vue?vue&type=template&id=2b5e0396&"
import script from "./VendorsTable.vue?vue&type=script&lang=js&"
export * from "./VendorsTable.vue?vue&type=script&lang=js&"
import style0 from "./VendorsTable.vue?vue&type=style&index=0&id=2b5e0396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports